import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import registerExtension from '../site-render/src/redux/registerExtension';
import couponSnackbar from '../site-render/src/redux/couponSnackbar';
import language from './language';

export default function(graphqlClient, initialState) {
  const composeEnhancers =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  return createStore(
    combineReducers({
      apollo: graphqlClient.reducer(),
      form: formReducer,
      registerExtension,
      language,
      couponSnackbar,
    }),
    initialState,
    composeEnhancers(applyMiddleware(graphqlClient.middleware())),
  );
}



// WEBPACK FOOTER //
// ./src/redux/createStore.js